import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";

import {Layout} from "../../../../layout/layout";

export const LoadItem = ({itemId, next}) => cs(
    consumeContext("apis"),
    ["itemId", (_, next) => next(itemId)],
    ["item", ({apis, itemId}, next) => Load({
        fetch: () => apis.next.item.getItem(itemId),
        next,
    })],
    ({item}) => !item ? (
        <Layout className="customize-layout-95r">
            <div className="product-options-step-6rz">
                <div className="center" xd-qa-type="label" xd-qa-name="Loading">
                    Loading Order...
                </div>
            </div>
        </Layout>
    ) : (
        !item?.sku?.front ? (
            <Layout className="customize-layout-95r">
                <div className="product-options-step-6rz">
                    <div className="center">
                        There was a problem locating your order.<br/>
                        Please go back and try again.
                    </div>
                </div>
            </Layout>
        ) : (
            next(item)
        )
    ),
);
